var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDownloadTick = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 3.99992L4.5 9.99992L1.75 7.24992L2.455 6.54492L4.5 8.58492L9.795 3.29492L10.5 3.99992Z",
  fill: "#8529FB"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadTick, _extends({
  svgRef: ref
}, props)));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgMy45OTk5Mkw0LjUgOS45OTk5MkwxLjc1IDcuMjQ5OTJMMi40NTUgNi41NDQ5Mkw0LjUgOC41ODQ5Mkw5Ljc5NSAzLjI5NDkyTDEwLjUgMy45OTk5MloiIGZpbGw9IiM4NTI5RkIiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };